import { createRouter, createWebHashHistory } from 'vue-router'
import global from '../util/global'

const routes = [
  {
    path: '/',
    name: 'home',
    component: () => import('../views/home.vue')//首页
  },
  {
    path: '/around',
    name: 'around',
    component: () => import('../views/around.vue')//周边
  },
  {
    path: '/allService',
    name: 'allService',
    component: () => import('../views/allService.vue')//全部服务
  },
  {
    path: '/destination',
    name: 'destination',
    component: () => import('../views/destination.vue')//目的地
  },
  {
    path: '/service',
    name: 'service',
    component: () => import('../views/service.vue')//服务
  },
  {
    path: '/mine',
    name: 'mine',
    component: () => import('../views/mine.vue')//我的
  },
  {
    path: '/specialTour',
    name: 'specialTour',
    component: () => import('../views/specialTour.vue')//特色之旅
  },
  {
    path: '/stDetail',
    name: 'stDetail',
    component: () => import('../views/stDetail.vue')//景区详情
  },
  {
    path: '/see5G',
    name: 'see5G',
    component: () => import('../views/see5G.vue')//5G看滨海
  },
  {
    path: '/GreatBeautyBinhai',
    name: 'GreatBeautyBinhai',
    component: () => import('../views/GreatBeautyBinhai.vue')//大美滨海
  },
  {
    path: '/festival',
    name: 'festival',
    component: () => import('../views/festival.vue')//节日节庆
  },
  {
    path: '/culture',
    name: 'culture',
    component: () => import('../views/culture.vue')//文化民俗
  },
  {
    path: '/vrDetail',
    name: 'vrDetail',
    component: () => import('../views/vrDetail.vue')//vr详情
  },
  {
    path: '/liveDetail',
    name: 'liveDetail',
    component: () => import('../views/liveDetail.vue')//5g详情
  },
  {
    path: '/beautyPic',
    name: 'beautyPic',
    component: () => import('../views/beautyPic.vue')//精选美图
  },
  {
    path: '/safeCall',
    name: 'safeCall',
    component: () => import('../views/safeCall.vue')//安全求助
  },
  {
    path: '/tourist',
    name: 'tourist',
    component: () => import('../views/tourist.vue')//景区舒适度
  },
  {
    path: '/mineService',
    name: 'mineService',
    component: () => import('../views/mineService.vue')//游客服务中心
  },
  {
    path: '/ShoppingDirectory',
    name: 'ShoppingDirectory',
    component: () => import('../views/ShoppingDirectory.vue')//购物指南
  },
  {
    path: '/shoppingInner',
    name: 'shoppingInner',
    component: () => import('../views/shoppingInner.vue')//购物指南内页
  },
  {
    path: '/evaluate',
    name: 'evaluate',
    component: () => import('../views/evaluate.vue')//评价
  },
  {
    path: '/aboutUs',
    name: 'aboutUs',
    component: () => import('../views/aboutUs.vue')//关于我们
  },
  {
    path: '/ActivityConsultation',
    name: 'ActivityConsultation',
    component: () => import('../views/ActivityConsultation.vue')//活动咨询
  },
  {
    path: '/acDetail',
    name: 'acDetail',
    component: () => import('../views/acDetail.vue')//活动咨询详情
  },
  {
    path: '/Transportation',
    name: 'Transportation',
    component: () => import('../views/Transportation.vue')//交通出行
  },
  {
    path: '/fesDetail',
    name: 'fesDetail',
    component: () => import('../views/fesDetail.vue')//节日节庆详情
  },
  {
    path: '/scenicSpotList',
    name: 'scenicSpotList',
    component: () => import('../views/scenicSpotList.vue')//景区列表
  },
  {
    path: '/hotelList',
    name: 'hotelList',
    component: () => import('../views/hotelList.vue')//酒店列表
  },
  {
    path: '/hotelInner',
    name: 'hotelInner',
    component: () => import('../views/hotelInner.vue')//酒店内页
  },
  {
    path: '/hotelDetail',
    name: 'hotelDetail',
    component: () => import('../views/hotelDetail.vue')//酒店详情
  },
  {
    path: '/CustomerService',
    name: 'CustomerService',
    component: () => import('../views/CustomerService.vue')//客服咨询
  },
  {
    path: '/TourismStrategy',
    name: 'TourismStrategy',
    component: () => import('../views/TourismStrategy.vue')//旅游攻略
  },
  {
    path: '/BoutiqueLine',
    name: 'BoutiqueLine',
    component: () => import('../views/BoutiqueLine.vue')//精品线路
  },
  {
    path: '/blInner',
    name: 'blInner',
    component: () => import('../views/blInner.vue')//精品线路内页
  },
  {
    path: '/tsInner',
    name: 'tsInner',
    component: () => import('../views/tsInner.vue')//旅游攻略境外游内页
  },
  {
    path: '/VideoAppreciation',
    name: 'VideoAppreciation',
    component: () => import('../views/VideoAppreciation.vue')//视频赏析
  },
  {
    path: '/vaInner',
    name: 'vaInner',
    component: () => import('../views/vaInner.vue')//视频内页
  },
  {
    path: '/restaurantFood',
    name: 'restaurantFood',
    component: () => import('../views/restaurantFood.vue')//美食餐厅列表
  },
  {
    path: '/RestaurantInner',
    name: 'RestaurantInner',
    component: () => import('../views/RestaurantInner.vue')//餐厅内页
  },
  {
    path: '/foodInner',
    name: 'foodInner',
    component: () => import('../views/foodInner.vue')//美食内页
  },
  {
    path: '/weather',
    name: 'weather',
    component: () => import('../views/weather.vue')//天气
  },
  {
    path: '/cultureDetail',
    name: 'cultureDetail',
    component: () => import('../views/cultureDetail.vue')//文化民俗详情
  },
  {
    path: '/complaint',
    name: 'complaint',
    component: () => import('../views/complaint.vue')//在线投诉
  },
  {
    path: '/Government',
    name: 'Government',
    component: () => import('../views/Government.vue')//政务公告
  },
  {
    path: '/gmDetail',
    name: 'gmDetail',
    component: () => import('../views/gmDetail.vue')//政务公告详情
  },
  {
    path: '/myCollect',
    name: 'myCollect',
    component: () => import('../views/myCollect.vue')//我的收藏
  },
  {
    path: '/ConsultationRecord',
    name: 'ConsultationRecord',
    component: () => import('../views/ConsultationRecord.vue')//咨询记录
  },
  {
    path: '/ShoppingConsultation',
    name: 'ShoppingConsultation',
    component: () => import('../views/ShoppingConsultation.vue')//购物咨询
  },
  {
    path: '/search',
    name: 'search',
    component: () => import('../views/search.vue')//搜索
  },
  {
    path: '/searchList',
    name: 'searchList',
    component: () => import('../views/searchList.vue')//搜索结果
  },
  {
    path: '/myOrder',
    name: 'myOrder',
    component: () => import('../views/myOrder.vue')//我的订单
  },
  {
    path: '/mySetting',
    name: 'mySetting',
    component: () => import('../views/mySetting.vue')//我的设置
  },
  {
    path: '/changeName',
    name: 'changeName',
    component: () => import('../views/changeName.vue')//修改姓名
  },
  {
    path: '/safeSetting',
    name: 'safeSetting',
    component: () => import('../views/safeSetting.vue')//安全设置
  },
  {
    path: '/tip',
    name: 'tip',
    component: () => import('../views/tip.vue')//购票须知
  },
  {
    path: '/policy',
    name: 'policy',
    component: () => import('../views/policy.vue')//隐私政策
  },
  {
    path: '/travelAgency',
    name: 'travelAgency',
    component: () => import('../views/travelAgency.vue')//旅行社名录
  },
  {
    path: '/safeNum',
    name: 'safeNum',
    component: () => import('../views/safeNum.vue')//安全求助
  },
  {
    path: '/ThematicActivities',
    name: 'ThematicActivities',
    component: () => import('../views/ThematicActivities.vue')//专题活动
  },{
    path: '/ThematicActivitiesList',
    name: 'ThematicActivitiesList',
    component: () => import('../views/ThematicActivitiesList.vue')//专题活动详情列表
  },{
    path: '/busList',
    name: 'busList',
    component: () => import('../views/busList.vue')//新交通出行
  },{
    path: '/serviceHotel',
    name: 'serviceHotel',
    component: () => import('../views/serviceHotel.vue')//酒店名录
  },{
    path: '/serviceShopping',
    name: 'serviceShopping',
    component: () => import('../views/serviceShopping.vue')//商场名录
  }
]

const router = createRouter({
  history: createWebHashHistory(process.env.BASE_URL),
  mode: 'history',
  routes
})

router.beforeEach((to, from, next) => { //beforeEach是router的钩子函数，在进入路由前执行
  if(global.token){
    sessionStorage.setItem('token',global.token)
  }
  if (to.meta.title) { //判断是否有标题
    document.title = to.meta.title
  }else{
    document.title =  '天津智慧文旅'
  }

  next()//执行进入路由，如果不写就不会进入目标页

})
export default router
